import { render, staticRenderFns } from "./ContentForm.vue?vue&type=template&id=4283ece0"
import script from "./ContentForm.vue?vue&type=script&lang=js"
export * from "./ContentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports